var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHedera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 0.0750424C7.75186 0.649309 3.6408 3.46019 1.59285 7.4045C0.39442 9.71668 0 11.3639 0 13.9783C0 17.4542 0.940539 20.1442 3.09468 22.8493C5.97697 26.446 10.9072 28.4559 15.5341 27.9119C21.6172 27.2016 26.4109 22.9097 27.7611 16.9404C28.0796 15.5047 28.0796 12.452 27.7611 11.0163C26.3503 4.77496 21.1014 0.362176 14.6845 0.0145933C13.9412 -0.0156313 12.8793 -0.000519027 12.3332 0.0750424ZM10.0577 9.59578V11.5604H14.0019H17.9461V9.59578V7.61607L18.9018 7.66141L19.8423 7.70675L19.8878 14.0086L19.9182 20.3255H18.9321H17.9461V18.3609V16.3963H14.0019H10.0577V18.3609V20.3255H9.07165H8.0856V14.0841C8.0856 10.6385 8.13111 7.78231 8.19179 7.73697C8.2373 7.67652 8.6924 7.63119 9.17784 7.63119H10.0577V9.59578Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0576 14.0539V15.0362H14.0018H17.946V14.0539V13.0716H14.0018H10.0576V14.0539Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHedera);
export default __webpack_public_path__ + "static/media/Hedera.5d1aa006c02ace260ffa919fdf3d74f4.svg";
export { ForwardRef as ReactComponent };